import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'app-aws-marketplace-error',
  templateUrl: './aws-marketplace-error.component.html',
  styleUrls: ['./aws-marketplace-error.component.scss'],
  standalone: false,
})
export class AwsMarketplaceErrorComponent implements OnInit {
  awsToken: string = null

  constructor(
    public uiService: UiService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.awsToken = this.activatedRoute.snapshot.queryParamMap.get('awsMarketplaceToken')
  }
}
